import { makeStyles } from "@material-ui/core/styles";

export default makeStyles(() => ({
  fecha: {
    marginTop: "10px"
  }
}));
